import { createContext, type MouseEventHandler } from "react";

interface SourcePreviewFooterLink {
    onClick?: MouseEventHandler;
}

// Set by the hover card, where the footer links to the source and reports its click as the pill does.
// A sources-list row renders the same previews inside its own link, so there the footer stays text.
export const SourcePreviewFooterLinkContext = createContext<SourcePreviewFooterLink | null>(null);
